export * from './lib/info-banner-ui.module';
